import { createContext, useContext, useState } from 'react';

const BriefLiveContext = createContext();

const initialState = {
  selectedTab: 'talkingPoint',
  errorProps: {},
  isOpenModalPrizeList: false,
  prizeListData: null,
  isOpenModalDetailWinner: false,
  selectedGiveawayId: null,
  detailWinnerPreviousModal: null,
  isOpenImagePreview: false,
  selectedImagePreview: [],
  imagePreviewPreviousModal: null,
};

const BRAND_SESSION_KEY = 'brief-live_brand';

const getInitialFilterState = () => {
  let brand = null;
  try {
    const s = sessionStorage.getItem(BRAND_SESSION_KEY);
    brand = s ? JSON.parse(s) : null;
  } catch {}
  return { page: 1, limit: 10, sort: null, brand, talkingPoint: { statusDraft: null, status: null }, giveaway: { promoSearch: '', status: null } };
};

const BriefLiveProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(getInitialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => {
    if (payload.brand !== undefined) sessionStorage.setItem(BRAND_SESSION_KEY, JSON.stringify(payload.brand));
    setFilterState((prev) => ({ ...prev, ...payload }));
  };
  const resetState = () => setState(initialState);
  const resetFilterState = () => setFilterState((prev) => ({ ...getInitialFilterState(), brand: prev.brand }));

  return (
    <BriefLiveContext.Provider value={{ updateState, updateFilterState, resetState, resetFilterState, state, filterState }}>
      {children}
    </BriefLiveContext.Provider>
  );
};

export const useBriefLiveState = () => {
  return useContext(BriefLiveContext);
};

export default BriefLiveProvider;
